import React from 'react';
import { getBrandName } from '../utils/brandUtils';

interface LoadingScreenProps {
  message?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ message }) => {
  const brandName = getBrandName();

  return (
    <div className="min-h-screen bg-base-100 flex items-center justify-center p-4">
      <div className="text-center space-y-4">
        {/* Brand name with breathing animation */}
        <h1 className="text-3xl md:text-4xl font-bold text-base-content animate-pulse">
          {brandName}
        </h1>
        
        {/* Optional message with animated dots */}
        {message && (
          <p className="text-base-content/60 text-sm md:text-base">
            {message}
            <span className="inline-flex ml-1">
              <span className="animate-[bounce_1s_ease-in-out_0ms_infinite]">.</span>
              <span className="animate-[bounce_1s_ease-in-out_200ms_infinite]">.</span>
              <span className="animate-[bounce_1s_ease-in-out_400ms_infinite]">.</span>
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

